import React, {useEffect, useState,useMemo} from 'react';
import { useParams,useLocation } from 'react-router-dom';
import {confirmRegister} from "../../network/ApiAxios";
import {Card, CardBody, Col} from "reactstrap";

const ConfirmEmail = props => {

    let { search } = useLocation(); //get referer from url
  const id=useMemo(() => {
    console.log(search)
    new URLSearchParams(search)
    return search.split('=')[1]
  }, [search])

    //const {id} = useParams();
    const [valid, setValid] = useState(true);
//console.log("confirm email render",useParams())
    useEffect(() => {
        if (!id) {
            setValid(false);
        } else {
            const runAsync = async () => {
                const response = await confirmRegister(id);
                const {data} = response;
                console.log(data);
                if (!data.success) {
                    setValid(false);
                } else {
                    setTimeout(() => {
                        props.history.push('/auth/login');
                    }, 5000);
                }
            }
            runAsync();
        }
    }, [])

    return (
        <>
            <Col lg="12" md="12">
                <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                        <div className="text-center mb-4">
                            <h1>{valid ? "Email confirmed! You will be redirected to login..." : "Something went wrong!"}</h1>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </>
    )
};

export default ConfirmEmail;
